import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { useNavigate, useParams } from "react-router-dom";

export const AdminManageLoadvelocityTrainingTemplateData = () => {
  const { staff } = useStaffAuthContext();
  const navigate = useNavigate();
  const { template_id } = useParams();

  const [templates, setTemplates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [week, setWeek] = useState("Week 1");
  const [day, setDay] = useState("Monday");
  const [training_focus,setTrainingFocus] = useState('');
  const [reps, setReps] = useState("");
  const [distance, setDistance] = useState("");
  const [rest, setRest] = useState("");
  const [trainingData, setTrainingData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    const fetchTemplates = async () => {
      setIsLoading(true);
      setError("");

      try {
        const response = await fetch(`${API_URL.MANAGE_LOADVELOCITY_TRAINING_TEMPLATES}?page=${page}&limit=${limit}`, {
          headers: {
            Authorization: `Bearer ${staff.token}`,
          },
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Failed to fetch templates");
        }

        setTemplates(data.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTemplates();
  }, [page, staff.token]);

  const fetchTrainingData = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL.GET_LOADVELOCITY_TRAINING_TEMPLATE_DATA}${template_id}`, {
        headers: {
          Authorization: `Bearer ${staff.token}`,
        },
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch training data");
      }
      setTrainingData(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTrainingData();
  }, [template_id]);

  const saveTrainingData = async () => {
    setSuccessMessage("");
    setError("");

    // Validation: Ensure training_focus is selected
    if (!training_focus) {
      setError("Please select a training focus.");
      return;
    }

    try {
      const response = await fetch(`${API_URL.POST_LOADVELOCITY_TRAINING_TEMPLATE_DATA}${template_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`,
        },
        body: JSON.stringify({ week_number: week, day,training_focus, reps, distance, rest }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to save training data");
      }
      fetchTrainingData();
      setReps("");
      //setDistance("");
      setRest("");
      //setTrainingFocus("");  // Reset the dropdown after save
      setSuccessMessage("Training data saved successfully!");
    } catch (error) {
      setError(error.message);
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      const response = await fetch(`${API_URL.DELETE_LOADVELOCITY_TRAINING_TEMPLATE_SET}${deleteId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${staff.token}`,
        },
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Failed to delete training data");
      }
      setSuccessMessage("Training data deleted successfully!");
      fetchTrainingData(); // Refresh left section after delete
      setDeleteId(null);
    } catch (error) {
      setError(error.message);
    }
  };

  const handleTrainingFocusChange = (e) => {
    const selectedFocus = e.target.value;
    setTrainingFocus(selectedFocus);
  
    // Prepopulate distance based on training focus
    const distanceMap = {
      "Technical": 20,
      "Speed - Strength": 15,
      "Power": 10,
      "Strength - Speed": 5,
    };
  
    if (selectedFocus in distanceMap) {
      setDistance(distanceMap[selectedFocus]); 
    } else {
      setDistance(""); // Reset if no valid selection
    }
  };


  

  return (
    <div className="flex h-screen">
      <StaffSideMenu />
      <div className="flex-1 p-6 bg-gray-100 pt-16 flex relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 right-4 bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
        >
          Go Back
        </button>
        <div className="w-1/2 h-screen bg-white shadow-md border-r flex flex-col">
            {/* Fixed Header */}
            <div className="p-6 border-b bg-white sticky top-0 z-10">
                <h2 className="text-2xl font-bold text-gray-800">Training Data</h2>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto p-6">
                {isLoading ? (
                <div className="text-center text-gray-600">Loading training data...</div>
                ) : trainingData.length === 0 ? (
                <div className="text-center text-gray-500">No training data available.</div>
                ) : (
                trainingData.map((weekData) => (
                    <div key={weekData.week_number} className="mb-6">
                    <h3 className="text-lg font-semibold text-gray-700 bg-gray-100 p-2 rounded">
                        {weekData.week_number}
                    </h3>
                    {weekData.days.map((dayData) => (
                        <div key={dayData.day} className="ml-4 mt-3">
                        <h4 className="text-md font-semibold text-gray-600 mb-2">{dayData.day} [{dayData.training_focus}]</h4>
                        <div className="space-y-1">
                            {dayData.sets.map((set, index) => (
                            <div
                                key={index}
                                className="flex items-center justify-between bg-gray-50 p-2 rounded shadow-sm border text-gray-700 text-sm"
                            >
                                <p>Reps: {set.reps} | Distance: {set.distance}m</p>
                                <div className="flex space-x-2">
                                <button onClick={()=> navigate('/administrator/loadvelocity/templates/edit-set/' + set._id)} className="text-blue-500 hover:text-blue-600 transition">Edit</button>
                                <button
                                className="text-red-500 hover:text-red-600 transition"
                                onClick={() => setDeleteId(set._id)}
                              >
                                Delete
                              </button>
                                </div>
                            </div>
                            ))}
                        </div>
                        </div>
                    ))}
                    </div>
                ))
                )}
            </div>

             {/* Delete Confirmation Modal */}
                {deleteId && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-20">
                    <div className="bg-white p-6 rounded shadow-lg">
                    <h2 className="text-xl font-semibold mb-4">Confirm Delete</h2>
                    <p>Are you sure you want to delete this entry?</p>
                    <div className="flex justify-end space-x-4 mt-4">
                        <button
                        onClick={() => setDeleteId(null)}
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                        >
                        Cancel
                        </button>
                        <button
                        onClick={handleDelete}
                        className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                        >
                        Delete
                        </button>
                    </div>
                    </div>
                </div>
            )}       



        </div>

        <div className="w-1/2 p-4">
          <h2 className="text-xl font-semibold mb-4">
            Training Focus: {templates.find((t) => t._id === template_id)?.title}
          </h2>
          {successMessage && (
            <div className="bg-green-100 text-green-700 p-2 mb-2 text-center rounded">{successMessage}</div>
          )}
           {error && (
            <div className="bg-red-100 text-red-700 p-2 mb-2 text-center rounded">{error}</div>
          )}
          <label>Week</label>
          <select className="w-full border rounded p-2 mb-2" value={week} onChange={(e) => setWeek(e.target.value)}>
            {Array.from({ length: 8 }, (_, i) => `Week ${i + 1}`).map((w) => (
              <option key={w} value={w}>
                {w}
              </option>
            ))}
          </select>
          <label>Day</label>
          <select className="w-full border rounded p-2 mb-2" value={day} onChange={(e) => setDay(e.target.value)}>
            {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
          <label>Training Focus <span className="text-red-500">*</span></label>
            <select
              className="w-full border rounded p-2 mb-2"
              value={training_focus}
              onChange={handleTrainingFocusChange} // Use new function here
            >
              <option value="">Select</option>
              <option value="Technical">Technical</option>
              <option value="Speed - Strength">Speed - Strength</option>
              <option value="Power">Power</option>
              <option value="Strength - Speed">Strength - Speed</option>
            </select>  


          <label>Reps</label>
          <input type="text" className="w-full border rounded p-2 mb-2" value={reps} onChange={(e) => setReps(e.target.value)} />
          <label>Distance</label>
          <input type="text" className="w-full border rounded p-2 mb-2" value={distance} onChange={(e) => setDistance(e.target.value)} />
          <label>Rest</label>
          <textarea className="w-full border rounded p-2 mb-2" value={rest} onChange={(e) => setRest(e.target.value)} />
          <div className="flex justify-center">
            <button onClick={saveTrainingData} className="bg-blue-500 text-white py-2 px-6 rounded hover:bg-blue-600">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
